/** The mobile CTA advances the same identity form, never a payment form. */
export function continueCheckoutIdentity() {
  const details = document.getElementById("checkout-customer-details");
  details?.querySelector<HTMLButtonElement>('form button[type="submit"]:not(:disabled)')?.click();
  const input = details?.querySelector<HTMLInputElement>('input:not([disabled]):not([readonly]):not([type="hidden"])');
  (input || details)?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  input?.focus({ preventScroll: true });
}
